import $ from 'jquery';
import Swiper from 'swiper';

/**
 * Initialize RSS Feed Swiper carousels
 */
export function initRSSFeedSwiper() {
	$('.rss-feed-scroll.swiper').each(function () {
		const $rss = $(this);
		const rssId = $rss.attr('id');

		if (rssId) {
			new Swiper(`#${rssId}`, {
				a11y: {
					enabled: true,
					slideRole: 'link',
				},
				navigation: {
					nextEl: `#${rssId} .swiper-button-next`,
					prevEl: `#${rssId} .swiper-button-prev`,
				},
				slidesPerView: 'auto',
				breakpoints: {
					320: {
						spaceBetween: 20,
					},
					1024: {
						spaceBetween: 30,
					},
				},
			});
		}
	});

	// Set equal height for RSS cards
	function setRSSHeight() {
		let maxHeight = 0;
		$('.rss-card-scroll').each(function () {
			const height = $(this).outerHeight();
			if (height > maxHeight) {
				maxHeight = height;
			}
		});
		$('.rss-card-scroll').css('min-height', maxHeight + 'px');
	}

	$(window).on('load', setRSSHeight);
	$(window).on('scroll', setRSSHeight);
}
